import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const settingsComputed = {
  ...mapState('settings', {
    settings: (state) => state.settings,
  })
}

export const utilsComputed = {
  ...mapState('util', {
    utils: (state) => state.utils,
  })
}

export const authMethods = mapActions('auth', ['logIn','changePassword', 'logOut', 'register', 'resetPassword'])
export const utilMethods = mapActions('util', ['setUtils'])
export const userMethods = mapActions('user',['createUser','updateUser','deleteUser','fetchUsers','fetchUser',])
//
export const lmsCreateUserMethods = mapActions('lmsCreateUser',['createLmsUser'])
export const lmsUserMethods = mapActions('lmsUser',['updateLmsUser','deleteLmsUser','fetchLmsUsers','fetchLmsUser'])
//
export const lmsCourseMethods = mapActions('lmsCourse',['createLmsCourse','fetchLmsCourses', 'deleteLmsCourse'])
//
export const personMethods = mapActions('person',['createPerson','updatePerson','deletePerson','fetchPersons','fetchPerson'])
export const personGroupMethods = mapActions('personGroup',['createPersonGroup','updatePersonGroup','deletePersonGroup','fetchPersonGroups','fetchPersonGroup'])
export const smsTemplateMethods = mapActions('smsTemplate',['createSmsTemplate','updateSmsTemplate','deleteSmsTemplate','fetchSmsTemplates','fetchSmsTemplate'])
export const smsLogMethods = mapActions('smsLog',['createSmsLog','updateSmsLog','deleteSmsLog','fetchSmsLogs','fetchSmsLog'])
export const smsMethods = mapActions('sms',['sendSms','fetchSendSmsList'])
export const noteMethods = mapActions('note',['createNote','deleteNote','fetchNotes'])
export const uploadMethods = mapActions('upload',['uploadFile'])
export const productMethods = mapActions('product',['createProduct','updateProduct','deleteProduct','fetchProducts','fetchProduct','fetchProductTransactions','createProductTransaction'])
export const customerMethods = mapActions('customer',['createCustomer','updateCustomer','deleteCustomer','fetchCustomers','fetchCustomer','fetchCustomerPayments','fetchCustomerSessions','fetchCustomerAgreementSessions'])
export const siteMethods = mapActions('site',['createSite','updateSite','deleteSite','fetchSites','fetchSite','fetchSitePayments'])
export const educationMethods = mapActions('education',['createEducation','updateEducation','deleteEducation','fetchEducations','fetchEducation'])
export const levelMethods = mapActions('level',['createLevel','updateLevel','deleteLevel','fetchLevels','fetchLevel'])
export const advisorMethods = mapActions('advisor',['createAdvisor','updateAdvisor','deleteAdvisor','fetchAdvisors','fetchAdvisor'])
export const saleMethods = mapActions('sale',['createSale','updateSale','deleteSale','fetchSales','fetchSale'])
export const campaignsMethods = mapActions('campaign',['createCampaign','updateCampaign','deleteCampaign','fetchCampaigns','fetchCampaign'])
export const courseMethods = mapActions('course',['createCourse','updateCourse','deleteCourse','fetchCourses','fetchCourse'])
export const contentMethods = mapActions('content',['createContent','updateContent','deleteContent','fetchContents','fetchContent'])
export const examMethods = mapActions('exam',['createExam','updateExam','deleteExam','fetchExams','fetchExam'])
export const sectionMethods = mapActions('section',['createSection','updateSection','deleteSection','fetchSections','fetchSection'])
export const questionMethods = mapActions('question',['createQuestion','updateQuestion','deleteQuestion','fetchQuestions','fetchQuestion'])
export const contractMethods = mapActions('contract',['createContract','updateContract','deleteContract','fetchContracts','fetchContract',])
export const contractPaymentMethods = mapActions('contractPayment',['createContractPayment','updateContractPayment','deleteContractPayment','fetchContractPayments','fetchContractPayment','payInstallment','makeDiscount','downPay','fetchPaymentLogs'])
export const contractProductMethods = mapActions('contractProduct',['createContractProduct','updateContractProduct','deleteContractProduct','fetchContractProducts','fetchContractProduct',])
export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])
export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])
export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])
export const bankPaymentMethods = mapActions('bankPayment',['createBankPayment','updateBankPayment','updateBankPaymentMulti','laterBankPayment','deleteBankPayment','fetchBankPayments'])
export const settingsMethods = mapActions('settings',['saveSettings','getSettings'])
export const reportMethods = mapActions('report',['fetchSalesReport','fetchPaymentReport','fetchDelayedInstallmentReport','fetchFullReport'])
export const dashboardMethod = mapActions('dashboard',['fetchDashboard'])

export const todoComputed = {
  ...mapState('todo', {
    todos: (state) => state.todos
  })
}
export const todoMethods = mapActions('todo', ['fetchTodos'])
